import { render, staticRenderFns } from "./create-figment.vue?vue&type=template&id=f5bd3a2e&"
import script from "./create-figment.vue?vue&type=script&lang=js&"
export * from "./create-figment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports